import { connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';
import { compose } from 'redux';
import styled from 'styled-components';
import { colors, Callout, Subhead } from 'styleguide';

import { CONTENT_PUBLISHED_STATES } from 'commons/models/notebook';
import TimeAgo from 'dashboard/components/TimeAgo';

const activeCardColor = colors('active', 1);

const hoverBgColor = ({ active }: { active: boolean }) =>
  active ? activeCardColor : colors('neutral', 5);

export const Container: any = styled.div`
  border-bottom: 1px solid ${colors('neutral', 4)};
  background-color: ${({ active }: { active: boolean }) =>
    active ? activeCardColor : colors('white')};
  color: ${({ active }: { active: boolean }) => (active ? colors('white') : colors('neutral'))};
  display: flex;
  flex-direction: column;
  padding: 0.6em 1.2em;
  position: relative;

  &:hover {
    cursor: pointer;
    background-color: ${hoverBgColor};
  }

  &:before {
    content: '';
    display: block;
    border-top: 12px solid transparent;
    border-left: 11px solid
      ${({ active }: { active: boolean }) => (active ? activeCardColor : 'transparent')};
    border-bottom: 12px solid transparent;
    position: absolute;
    top: 50%;
    right: -11px;
    transform: translateY(-12px);
    z-index: 10;
  }
`;

interface Props {
  active: boolean;
  customer: any;
  createdAt: string;
  historyId: string;
  publishedState: string;
  changeHistory: (historyId: string) => void;
}

export const HistoryCard = ({
  active,
  customer,
  createdAt,
  historyId,
  publishedState,
  changeHistory,
}: Props) => {
  const { color, shade }: any = active
    ? { color: 'white', shade: 0 }
    : { color: 'neutral', shade: 2 };

  return (
    <Container active={active} onClick={() => changeHistory(historyId)}>
      <Subhead color={active ? 'white' : 'primary'}>
        <TimeAgo date={createdAt} />
      </Subhead>
      <Callout color={color} shade={shade}>
        {publishedState === CONTENT_PUBLISHED_STATES.PUBLISHED ? 'Published' : 'Changes made'} by{' '}
        {customer.email}
      </Callout>
    </Container>
  );
};

const withAuthorHammock = connectWithHammock(({ authorId }) => ({
  resourceName: 'customer',
  endpoint: ENDPOINTS.customers,
  id: authorId,
}));

export default compose(withAuthorHammock)(HistoryCard);
